<template>
  <div>
    <filtro-cadu
      v-model="valueData"
      @limparFiltro="limparFiltro()"
      @filtrar="filtrar() "
      width="390"
    >
      <div slot="body" class="ml-5">
        <v-row class="pb-0">
          <v-col cols="auto">
            <div class="fontColor1--text font-weight-bold">FILTRAR APLICAÇŌES</div>
          </v-col>
        </v-row>
        <ValidationObserver ref="observer">
          <v-row class="pt-0">
            <v-col cols="11" class="pb-0 pt-3">
              <autocomplete-cadu
                placeholder
                title="Buscar por Aplicação"
                v-model="aplicacaoSelecionada"
                :items="listaAplicacao"
              />
            </v-col>
          </v-row>

        <v-row class="mt-2">
          <v-col>
            <span>Período de Geração</span>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="5" class="mx-1">
            <datepicker-cadu
              typeCalendar="date"
              :menuOpen="menuOpen"
              :validateProviderRules="periodoGeracao.dataInicial ? 'dateValidatorForPass|required' : '' "
              :inputTitle="'Data Inicial'"
              :inputValue="periodoGeracao.dataInicial"
              :maxDate="today"
              @value="value => periodoGeracao.dataInicial = value"
              width="280"
            ></datepicker-cadu>
          </v-col>
          <v-col cols="5" class="mx-5">
            <datepicker-cadu
              typeCalendar="date"
              :menuOpen="menuOpen"
              :validateProviderRules="regrasDataFinalGeracao"
              :inputTitle="'Data Final'"
              :inputValue="periodoGeracao.dataFinal"
              :maxDate="today"
              @value="value => periodoGeracao.dataFinal = value"
              width="280"
            ></datepicker-cadu>
          </v-col>
        </v-row>

        <v-row class="mt-2">
          <v-col>
            <span>Período de Expiração</span>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="5" class="mx-1">
            <datepicker-cadu
              :menuOpen="menuOpen"
              :inputTitle="'Data Inicial'"
              :validateProviderRules="periodoExpiracao.dataInicial ? 'dateValidatorForFuture|required' : '' "
              :inputValue="periodoExpiracao.dataInicial"
              :minDate="today"
              typeCalendar="date"
              @value="value => periodoExpiracao.dataInicial = value"
              width="280"
            ></datepicker-cadu>
          </v-col>
          <v-col cols="5" class="mx-5">
            <datepicker-cadu
              :menuOpen="menuOpen"
              :validateProviderRules="regrasDataFinalExpiracao"
              :inputTitle="'Data Final'"
              :inputValue="periodoExpiracao.dataFinal"
              :minDate="today"
              @value="value => periodoExpiracao.dataFinal = value"
              typeCalendar="date"
              width="280"
            ></datepicker-cadu>
          </v-col>
        </v-row>
      </ValidationObserver>
        <v-row class="mt-2">
          <v-col class="pb-0 mx-1">
            <span>Status</span>
          </v-col>
        </v-row>
        <v-row no-gutters class="mt-0 mb-2">
          <v-col cols="auto" class="ml-2">
            <checkbox-cadu v-model="check" obligatory single value="ATIVO" rounded>
              <div slot="text">Ativo</div>
            </checkbox-cadu>
          </v-col>
          <v-col cols="auto" class="ml-4">
            <checkbox-cadu v-model="check"  obligatory single value="INATIVO" rounded>
              <div slot="text">Inativo</div>
            </checkbox-cadu>
          </v-col>
          <v-col cols="auto" class="ml-4">
            <checkbox-cadu v-model="check" obligatory single value="TODOS" rounded>
              <div slot="text">Todos</div>
            </checkbox-cadu>
          </v-col>
        </v-row>
      </div>
    </filtro-cadu>
    <error-modal v-model="error" :errObj="errObj" />
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import moment from 'moment'

import GerenciamentoToken from '../../../../../services/GerenciamentoToken/GerenciamentoToken'

export default {
  components: {
    ValidationObserver
  },

  props: {
    value: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      valueData: this.value,
      tokenBearer: localStorage.getItem('tokenBearer'),
      menuOpen: false,
      today: moment().format('DD/MM/YYYY'),

      // Model Aplicacao Autocomplete
      aplicacaoSelecionada: '',
      listaAplicacao: [],

      periodoGeracao: {
        dataInicial: '',
        dataFinal: ''
      },

      periodoExpiracao: {
        dataInicial: '',
        dataFinal: ''
      },

      // Erro
      error: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      },

      check: ['ATIVO']
    }
  },

  methods: {
    limparFiltro () {
      this.aplicacaoSelecionada = ''
      this.periodoGeracao.dataInicial = ''
      this.periodoGeracao.dataFinal = ''
      this.periodoExpiracao.dataInicial = ''
      this.periodoExpiracao.dataFinal = ''
      this.check = ['ATIVO']
    },

    async filtrar () {
      const res = await this.$refs.observer.validate()
      if (!res) return

      const objetoFiltro = {
        aplicacao: this.aplicacaoSelecionada,
        periodoGeracaoInicial: this.periodoGeracao.dataInicial,
        periodoGeracaoFinal: this.periodoGeracao.dataFinal,
        periodoExpiracaoInicial: this.periodoExpiracao.dataInicial,
        periodoExpiracaoFinal: this.periodoExpiracao.dataFinal,
        check: this.check[0]
      }
      this.$emit('filtrar', objetoFiltro)
      this.valueData = false
    },

    async getAplicacoes () {
      let gerenciamento = new GerenciamentoToken(
        this.tokenBearer,
        this.$appConfig.config.API
      )

      try {
        let response = await gerenciamento.getAplicacoes()
        this.listaAplicacao = response.data
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    }
  },

  computed: {
    regrasDataFinalGeracao () {
      if (this.periodoGeracao.dataInicial) {
        return `dateValidatorForPass|validateDataMandato: ${this.periodoGeracao.dataInicial} `
      } else {
        return 'dateValidatorForPass'
      }
    },
    regrasDataFinalExpiracao () {
      if (this.periodoExpiracao.dataInicial) {
        return `dateValidatorForFuture|validateDataMandato: ${this.periodoExpiracao.dataInicial} `
      } else {
        return 'dateValidatorForFuture'
      }
    }
  },

  watch: {
    valueData () {
      if (!this.valueData) {
        this.$emit('input', false)
      } else {
        this.getAplicacoes()
      }
    },
    value () {
      this.valueData = this.value
    }
  }
}
</script>
